import * as React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid2';
import homeImg from "../media/home.jpg";
import '../styles/home.css';
import Typography from "@mui/material/Typography";

export default function Home() {
    return (
        <Box id="home" sx={{ flexGrow: 1, height: '400px', overflow: 'hidden' }}>
            <Grid container spacing={0}>
                <Grid size={12}>
                    <div className="home-image-container">
                        <div className="home-text-container"></div>
                        <div className="home-text">
                            <Typography sx={{ color: 'gold', display: 'flex', alignItems: 'center' }} variant="h5" component="h5">
                                <hr className="middle-line" /> TRAVEL & TOUR
                            </Typography>
                            <Typography sx={{ marginTop: '15px', textAlign: 'center' }} variant="h4" gutterBottom>
                                Get ready to explore the world!
                            </Typography>
                            <Typography sx={{ marginTop: '15px', textAlign: 'justify' }} variant="body1" gutterBottom>
                                Embark on a journey like no other with Voyage Vibes, where every destination becomes a story waiting to be told. Whether you're exploring vibrant cities or serene landscapes, we craft experiences that leave you with unforgettable memories. Let us take you to the world’s most breathtaking places, where adventure, culture, and luxury meet. Travel with us, and let the world be your playground.
                            </Typography>
                        </div>
                        <img className="image" src={homeImg} alt="Voyage Vibes" />
                    </div>
                </Grid>
            </Grid>
        </Box>
    );
}